import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { delay, filter, map, Observable, take } from 'rxjs';
import { MAIN_MENU } from '@nx-icilalune/data/icilalune/tokens';
import { Tree } from '@nx-icilalune/drupal-types';
import { MainMenuTreeItem } from '@nx-icilalune/data/icilalune/types';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class MainMenuGuard implements CanActivate {
  constructor(
    @Inject(DOCUMENT)
    private document: Document,
    @Inject(MAIN_MENU)
    private mainMenu$: Observable<Tree<MainMenuTreeItem>>
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.mainMenu$.pipe(
      filter((mainMenu) => mainMenu?.items?.length > 0),
      take(1),
      map((mainMenu) => {
        const codeElement = this.document.getElementById('scullyDebug');
        if (codeElement) {
          codeElement.innerHTML = codeElement.innerHTML + 'mainMenu OK ';
        }
        return true;
      })
    );
  }
}
